// src/utils/plural.ts
import { PluralTranslations } from '../locales/interfaces/plural';

// Forma rzeczownika po liczbie, wg reguły polskiej: 1 — one; 2–4, 22–24 itd. (bez 12–14) — few; reszta — many.
// Angielskie pliki tłumaczeń mają te same trzy klucze z jednakowymi few i many, więc ta reguła wybiera dobrze
// i dla nich. Użycie: t(`student:list.count.${pluralForm(n)}`, { n })
export const pluralForm = (count: number): keyof PluralTranslations => {
  if (count === 1) return 'one';

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) return 'few';

  return 'many';
};
